export enum InvoiceDetailsNotesColumns {
  RegistrationDate,
  Description,
  UserId,
  Note,
}
